__turbopack_context__.v({
  "container": "SkXJ1q_container",
  "image": "SkXJ1q_image",
});
